import axios, { AxiosResponse } from "axios";
import { BASE_URL } from "../config/api_collection";
import apolloClient from "../graphql";
import { BOOKING_RESET } from "../graphql/mutation";
import { MANAGE_BOOKING_RETRIEVE } from "../graphql/queries";
import { getToken } from "../helper/token";
import { getHeaderData } from "./crm";
import { BOOKING_IS_ETIHAD_BOOKING } from "constants/variables";

const GET_CURRENT_BOOKING_IN_STATE = `${BASE_URL}/api/ibe/booking`;
const GET_GROUP_BOOKING_IN_STATE = `${BASE_URL}/api/ibe/groupBooking/getGroupBookingInState`;
const RETRIEVE_BOOKING_WITH_PARAMS = `${BASE_URL}/api/ibe/booking/retrieve`;
const RETRIVE_BOOKING_WITHOUT_PNR = `${BASE_URL}/api/ibe/booking/retrieve/phone`;
const ADD_BOOKING_IN_MY_TRIP = `${BASE_URL}/api/ibe/users/me/bookings`;
const FARE_MASKING_STATUS_API = `${BASE_URL}/api/ibe/booking`;
const MANAGE_BOOKING_RESTRICTIONS = `${BASE_URL}/api/ibe/booking/restrictions`;
const REFUND_IN_STATE = `${BASE_URL}/api/ibe/refund_info/get`

export const getBookingDetails = async (params: any) => {
  const response = await apolloClient
    .query({
      query: MANAGE_BOOKING_RETRIEVE,
      variables: {
        request: {
          recordLocator: params?.pnrDetails,
          lastName: params?.lastName,
          emailAddress: params?.email,
          customerNumber: params?.phone,
          departureDate: params?.departureDate,
          origin: params?.destinationFrom
        }
      },
      fetchPolicy: "no-cache"
    })
    .catch((err) => console.error(err));
  return response;
};

export async function getPreviousBookingDetails() {
  try {
    const headers = await getToken(true);
    const cognitoToken = sessionStorage?.getItem("auth-access-token");
    headers["x-session-token"] = `Bearer ${cognitoToken}`;

    const url = `${ADD_BOOKING_IN_MY_TRIP}?limit=50&page=1&filter=PAST`;

    const response = await axios.get(url, { headers });
    return response;
  } catch (error) {
    console.warn("error in get Previous Booking Details API:", error.message);
  }
}

export async function getUpcomingBookingDetails() {
  try {
    const headers = await getToken(true);
    const cognitoToken = sessionStorage?.getItem("auth-access-token");
    headers["x-session-token"] = `Bearer ${cognitoToken}`;

    const url = `${ADD_BOOKING_IN_MY_TRIP}?limit=50&page=1&filter=UPCOMING`;

    const response = await axios.get(url, { headers });
    return response;
  } catch (error) {
    console.warn("error in get Upcoming Booking Details API:", error.message);
  }
}

export const getBookingDetailsWithUserInfo = async (params: any) => {
  try {
    const headers = await getToken(true);

    let url = `${RETRIEVE_BOOKING_WITH_PARAMS}?`;
    if (params?.pnrDetails) {
      url += `recordLocator=${params?.pnrDetails}`;
    }
    if (params?.lastName) {
      url += `&lastName=${params?.lastName}`;
    }
    if (params?.email) {
      url += `&emailAddress=${params?.email}`;
    }
    const response = await axios.get(url, { headers });
    return response;
  } catch (error: any) {
    if (error.response.data.error.status === "FORBIDDEN") {
      return BOOKING_IS_ETIHAD_BOOKING;
    } else {
      return false;
    }
  }
};

export const getBookingDetailsWithoutPNR = async (params: any) => {
  try {
    const headers = await getToken(true); 

    let url = `${RETRIVE_BOOKING_WITHOUT_PNR}?`;
    if (params?.phone) {
      url += `phoneNumber=${(params?.phone)}`;
    }
    if (params?.originStationCode) {
      url += `&origin=${(params?.originStationCode)}`;
    }
    if (params?.departureDate) {
      url += `&departureDate=${(params?.departureDate)}`;
    }
    if (params?.destinationStatusCode) {
      url += `&destination=${(params?.destinationStatusCode)}`;
    }
    const response = await axios.get(url, { headers });
    
    return response;
  } catch (error) {
    console.warn("error", error);
    return false;
  }
  
};

export const getRefundInState = async(params: { pnrDetails: string; lastNameOrEmail: string; })=> {
  try{
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const headers = getHeaderData();
    let url = `${REFUND_IN_STATE}?`;
    if (params?.pnrDetails) {
      url += `recordLocator=${params?.pnrDetails}`;
    }
    if (emailRegex.test(params?.lastNameOrEmail)) {
      url += `&email=${params?.lastNameOrEmail}`;
    } else if (params?.lastNameOrEmail) {
      url += `&lastName=${params?.lastNameOrEmail}`;
    }
    const response = await axios.get(url, { headers });
    return response;
  }catch(error){
    console.warn("error",error);
    return error;
  }
}


export async function addBookingInMyTripAPI() {
  try {
    const token = localStorage.getItem("token");
    const cognitoToken = sessionStorage?.getItem("auth-access-token");

    const response = await fetch(ADD_BOOKING_IN_MY_TRIP, {
      method: "PUT",
      headers: {
        Authorization: token,
        "x-session-token": `Bearer ${cognitoToken}`
      }
    });
    return response;
  } catch (error) {
    console.warn("error in add Booking In MyTrip API:", error.message);
  }
}

// reset booking

export const resetBookingAPI = async () => {
  const response = await apolloClient
    .mutate({
      mutation: BOOKING_RESET,
      variables: {}
    })
    .catch((err) => console.error(err));
  return response;
};

export const getFareMaskData = async () => {
  try {
    const token = localStorage.getItem("token");
    const headers = {
      Authorization: token
    };
    const response = await axios.get(FARE_MASKING_STATUS_API, { headers });
    return response;
  } catch (error) {
    console.warn("error", error);
    return false;
  }
};

export const getManageBookingRestrictionsData = async (): Promise<AxiosResponse<any, any> | false> => {
  try {
    const headers = await getToken();
    const res = await axios.get(MANAGE_BOOKING_RESTRICTIONS, { headers });
    return res;
  } catch (error) {
    console.warn("error in fetch Manage Booking Restrictions API:", error);
    return false;
  }
};

export const getCurrentBookingInState = async (): Promise<AxiosResponse<any, any> | false> => {
  try {
    const groupBookingString = sessionStorage.getItem("groupBooking");
    const isGroupBookingRetrieved = groupBookingString === 'true';

    const passnegerKeys = sessionStorage.getItem('passnegerKeys');
    const passnegerKeysArr = passnegerKeys ? JSON.parse(passnegerKeys) : [];
    const headers = await getHeaderData();
    let response;

    if(isGroupBookingRetrieved) {
      response = await axios.post(GET_GROUP_BOOKING_IN_STATE, passnegerKeysArr, { headers });
    }else{
      response = await axios.get(GET_CURRENT_BOOKING_IN_STATE, { headers });
    }
    return response;
  } catch (error) {
    console.warn("error in fetch Manage Booking Restrictions API:", error);
    return false;
  }
};
